module.exports = __webpack_public_path__ + "img/dsci0009.97dd1fe0.jpg";